import * as React from "react"

import { cn } from "@/lib/utils"
import { noAutofillProps } from "@/lib/no-autofill"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      // Browser-level autofill suppression applied as DEFAULTS (18/02/2026).
      // See /app/frontend/src/lib/no-autofill.js. Caller props win via the
      // trailing `{...props}` spread.
      {...noAutofillProps}
      className={cn(
        "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
